<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
              <div class="filter-select-div el-div-long mb11">
                <span class="filter-select-span mr20">서버</span>
                <el-select v-model="filterStatus" class="select mr5" @change="setFilterFunc('server', filterStatus)">
                    <el-option :value="''" :label="'전체'"></el-option>
                    <el-option :value="1" :label="'국내'"></el-option>
                    <el-option :value="2" :label="'국외'"></el-option>
                </el-select>
            </div>
            <div class="filter-show-count">    
                <el-select v-model="size" @change="changePage('size', size)">
                    <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                               :label="`${sizeData}개씩 보기`"></el-option>
                </el-select>
            </div>
  
        </div>
    </div>
  </template>
  
  <script>
  import logUtil from "@/components/log/logUtil";
  import util from "@/mixins/util";
  
  const {filterConfig} = logUtil;
  export default {
    name: "LogFilterDailyLayout",
    mixins: [],
    components: {},
    inject: ['setPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
                return {}
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
  
    },
    data() {
        return {
            filterStatus:'',
            searchInput: '',
            searchInputOption:'br',
            filterDate: [],
            size: 10,
            sizeList: [10, 30, 50],
        }
    },
    created() {
    },
    mounted() {
        this.setterFilterDataInData();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
          setterFilterDataInData() {
              let classnames = Object.keys(this.filterData);
              classnames.forEach(classname => {
                  let obj = this.filterData[classname];
                  let type = filterConfig[obj.key].type;
                  if (this.hasOwnProperty(classname)) {
                      if (type == 'query') {
                          this[classname] = obj.query;
                      } else if (type === 'between') {
                          this[classname] = [obj.start, obj.end];
                      } else if (type === 'match') {
                          if (isNaN(obj.value)) {
                              this[classname] = obj.value;
                          } else {
                              this[classname] = Number(obj.value);
                          }
  
                      }
  
                  }
              })
              this.size = this.paginationData.size;
          },
          setFilterFunc(key, value) {
              this.setFilter(key, value);
          },
          changePage(key, value) {
            this.setPage(key, value);
            this.setPage('page', 1);
          },
          checkFilterData() {
              return this.filterDate != null && this.filterDate.length > 0;
          },
          setFilterDate(classname, value) {
              let date = []
              if (!util.isEmpty(value)) {
                  // date[0] = this.$moment(`${value[0]} 00:00:00`).format('X')
                  // date[1] = this.$moment(`${value[1]} 23:59:59`).format('X')
                  // this.setFilterFunc('cr', date);
                  this.setFilterFunc('cr', value);
              } else this.setFilterFunc('cr', this[classname]);
          },
  
    },
    watch: {},
  }
  </script>